document.addEventListener('DOMContentLoaded', () => {
  const accordionWrappers = document.querySelectorAll('.accordion-main-container');

  accordionWrappers.forEach(wrapper => {
    const accordionItems = wrapper.querySelectorAll('.accordion-item');
    const imgDesktop = wrapper.querySelector('.image-desktop');

    function activateItem(item) {
      const content = item.querySelector('.accordion-content');
      const iconPlus = item.querySelector('.icon-plus');
      const iconMinus = item.querySelector('.icon-minus');
      const spacer = item.querySelector('.accordion-spacer');

      item.classList.add('active');
      if (content) content.style.maxHeight = `${content.scrollHeight}px`;

      if (iconPlus && iconMinus) {
        iconPlus.classList.add('hidden');
        iconMinus.classList.remove('hidden');
      }

      if (window.innerWidth < 1024 && spacer) {
        spacer.style.maxHeight = '0px';
      }

      const desktopImg = item.dataset.imgDesktop;
      if (imgDesktop && desktopImg) {
        imgDesktop.src = desktopImg;
      }
    }

    function deactivateAllItems() {
      accordionItems.forEach((i) => {
        i.classList.remove('active');
        const content = i.querySelector('.accordion-content');
        const iconPlus = i.querySelector('.icon-plus');
        const iconMinus = i.querySelector('.icon-minus');
        const spacer = i.querySelector('.accordion-spacer');

        if (content) content.style.maxHeight = null;

        if (iconPlus && iconMinus) {
          iconPlus.classList.remove('hidden');
          iconMinus.classList.add('hidden');
        }

        if (spacer && window.innerWidth < 1024) {
          spacer.style.maxHeight = '32px';
        }
      });
    }

    function setupAccordionListeners() {
      accordionItems.forEach((item) => {
        const header = item.querySelector('.accordion-header');
        if (!header) return;

        header.addEventListener('click', (e) => {
          e.stopPropagation();
          const isActive = item.classList.contains('active');
          deactivateAllItems();
          if (!isActive) activateItem(item);
        });
      });
    }

    function updateSpacerAndImageOnResize() {
      accordionItems.forEach((item) => {
        const isActive = item.classList.contains('active');
        const spacer = item.querySelector('.accordion-spacer');
        const content = item.querySelector('.accordion-content');

        if (spacer) {
          if (window.innerWidth < 1024) {
            spacer.style.maxHeight = isActive ? '0px' : '32px';
          } else {
            spacer.style.maxHeight = '';
          }
        }

        if (isActive && content) {
          content.style.maxHeight = `${content.scrollHeight}px`;
        }
      });
    }

    // Init accordion
    if (accordionItems.length > 0) {
      const firstItem = accordionItems[0];
      const desktopImg = firstItem.dataset.imgDesktop;
      if (imgDesktop && desktopImg) {
        imgDesktop.src = desktopImg;
      }
      firstItem.classList.add('active');
      activateItem(firstItem);
    }

    accordionItems.forEach((item) => {
      const desktopImg = item.dataset.imgDesktop;
      if (desktopImg) {
        const img = new Image();
        img.src = desktopImg;
      }
    });

    setupAccordionListeners();
    updateSpacerAndImageOnResize();
    window.addEventListener('resize', updateSpacerAndImageOnResize);
  });
});
